<div class="header">
  <div class="logo logo-dark">
    <a href="">
      <div class="m-t-20">
        <svg
          class="full-logo"
          xmlns="http://www.w3.org/2000/svg"
          width="130"
          height="27"
          viewBox="0 0 130 27"
          fill="none"
        >
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M21.9699 4.73964C21.9699 5.39786 21.9699 6.05609 22.0012 6.74497C22.1256 13.3573 22.2819 22.3512 11.3133 26.143L11.0002 26.2031L10.6864 26.143C6.84583 24.8194 4.37223 22.8561 2.78048 20.5833C2.78416 20.5752 2.78785 20.5671 2.79155 20.5591C-0.147356 16.3406 -0.0538935 11.0576 0.0276889 6.79059C0.0187674 6.7896 0.00984054 6.78862 0.000908355 6.78765V6.74497C0.0321665 6.05609 0.0321665 5.40087 0.0321665 4.73964C0.029883 4.61555 0.0526406 4.49227 0.099079 4.37718C0.145517 4.26208 0.214683 4.15753 0.302443 4.06977C0.390203 3.98201 0.494755 3.91284 0.609851 3.8664C0.724947 3.81997 0.848224 3.79721 0.972314 3.79949C4.8898 3.79949 7.86713 2.67119 10.3455 0.258309C10.5245 0.0922668 10.7596 0 11.0038 0C11.2479 0 11.483 0.0922668 11.662 0.258309C14.1344 2.67119 17.1117 3.79949 21.0298 3.79949C21.1539 3.79721 21.2772 3.81997 21.3923 3.8664C21.5074 3.91284 21.6119 3.98201 21.6997 4.06977C21.7874 4.15753 21.8566 4.26208 21.903 4.37718C21.9495 4.49227 21.9722 4.61555 21.9699 4.73964Z"
            fill="#89D5A3"
          />
          <path
            d="M35.0969 22.6769V5.62231H38.7515V19.3878H46.4747V22.6769H35.0969Z"
            fill="#263248"
          />
          <path
            d="M48.7027 22.6769V9.7885H52.1623V22.6769H48.7027ZM50.4081 7.13286C49.7422 7.13286 49.2224 6.97044 48.8489 6.64559C48.4753 6.32074 48.2885 5.85783 48.2885 5.25686C48.2885 4.70462 48.4753 4.25795 48.8489 3.91686C49.2387 3.55953 49.7584 3.38086 50.4081 3.38086C51.0741 3.38086 51.5938 3.5514 51.9674 3.8925C52.341 4.21734 52.5278 4.67213 52.5278 5.25686C52.5278 5.82535 52.3329 6.28013 51.9431 6.62122C51.5695 6.96232 51.0578 7.13286 50.4081 7.13286Z"
            fill="#263248"
          />
          <path
            d="M55.8818 22.6769V8.88704C55.8818 8.09116 56.0604 7.36838 56.4178 6.71868C56.7751 6.06898 57.2624 5.55735 57.8796 5.18377C58.5131 4.81019 59.2521 4.62341 60.0967 4.62341C60.6652 4.62341 61.2012 4.72086 61.7047 4.91577C62.2082 5.09444 62.6386 5.34619 62.996 5.67104L61.9727 8.20486C61.7615 8.07492 61.5423 7.96935 61.3149 7.88813C61.1037 7.79068 60.9088 7.74195 60.7301 7.74195C60.4215 7.74195 60.1617 7.7988 59.9505 7.9125C59.7556 8.00995 59.6094 8.16426 59.512 8.37541C59.4145 8.57032 59.3658 8.82207 59.3658 9.13068V22.6769H57.636C57.2624 22.6769 56.9294 22.6769 56.6371 22.6769C56.3447 22.6769 56.0929 22.6769 55.8818 22.6769ZM53.9571 13.0289V10.1052H62.1432V13.0289H53.9571Z"
            fill="#263248"
          />
          <path
            d="M69.1124 22.9205C67.7155 22.9205 66.4973 22.6363 65.4578 22.0678C64.4183 21.4993 63.6062 20.7197 63.0215 19.7289C62.4367 18.7381 62.1444 17.6011 62.1444 16.318C62.1444 15.3272 62.3068 14.4176 62.6316 13.5892C62.9565 12.7609 63.4113 12.0462 63.996 11.4452C64.5807 10.828 65.271 10.357 66.0669 10.0321C66.879 9.69104 67.7561 9.5205 68.6982 9.5205C69.5753 9.5205 70.3874 9.68292 71.1346 10.0078C71.8817 10.3164 72.5233 10.763 73.0593 11.3478C73.6115 11.9163 74.0338 12.5903 74.3262 13.37C74.6186 14.1496 74.7485 15.0023 74.716 15.9281L74.6917 17.0001H64.3371L63.7767 14.8805H71.8411L71.4513 15.319V14.783C71.4188 14.3445 71.2726 13.9466 71.0127 13.5892C70.7691 13.2319 70.4524 12.9558 70.0626 12.7609C69.6727 12.566 69.2342 12.4685 68.7469 12.4685C68.0323 12.4685 67.4232 12.6066 66.9197 12.8827C66.4324 13.1588 66.0588 13.5649 65.7989 14.1009C65.539 14.6369 65.4091 15.2866 65.4091 16.05C65.4091 16.8296 65.5715 17.5037 65.8964 18.0721C66.2375 18.6406 66.7085 19.0873 67.3095 19.4121C67.9267 19.7207 68.6495 19.875 69.4778 19.875C70.0463 19.875 70.5661 19.7857 71.0371 19.607C71.5081 19.4284 72.0117 19.1198 72.5477 18.6812L74.2044 20.9958C73.7334 21.4181 73.2136 21.7754 72.6451 22.0678C72.0766 22.3439 71.4919 22.5551 70.8909 22.7012C70.29 22.8474 69.6971 22.9205 69.1124 22.9205Z"
            fill="#263248"
          />
          <path
            d="M88.1093 22.6769V5.62231H91.7638V22.6769H88.1093ZM77.3649 22.6769V5.62231H81.0195V22.6769H77.3649ZM78.8267 15.8307L78.8511 12.5172H89.9853V15.8307H78.8267Z"
            fill="#263248"
          />
          <path
            d="M100.862 22.9205C99.4653 22.9205 98.2471 22.6363 97.2076 22.0678C96.1681 21.4993 95.3559 20.7197 94.7712 19.7289C94.1865 18.7381 93.8941 17.6011 93.8941 16.318C93.8941 15.3272 94.0565 14.4176 94.3814 13.5892C94.7062 12.7609 95.161 12.0462 95.7458 11.4452C96.3305 10.828 97.0208 10.357 97.8167 10.0321C98.6288 9.69104 99.5059 9.5205 100.448 9.5205C101.325 9.5205 102.137 9.68292 102.884 10.0078C103.631 10.3164 104.273 10.763 104.809 11.3478C105.361 11.9163 105.784 12.5903 106.076 13.37C106.368 14.1496 106.498 15.0023 106.466 15.9281L106.441 17.0001H96.0868L95.5265 14.8805H103.591L103.201 15.319V14.783C103.169 14.3445 103.022 13.9466 102.762 13.5892C102.519 13.2319 102.202 12.9558 101.812 12.7609C101.422 12.566 100.984 12.4685 100.497 12.4685C99.782 12.4685 99.1729 12.6066 98.6694 12.8827C98.1821 13.1588 97.8085 13.5649 97.5487 14.1009C97.2888 14.6369 97.1588 15.2866 97.1588 16.05C97.1588 16.8296 97.3213 17.5037 97.6461 18.0721C97.9872 18.6406 98.4582 19.0873 99.0592 19.4121C99.6764 19.7207 100.399 19.875 101.228 19.875C101.796 19.875 102.316 19.7857 102.787 19.607C103.258 19.4284 103.761 19.1198 104.297 18.6812L105.954 20.9958C105.483 21.4181 104.963 21.7754 104.395 22.0678C103.826 22.3439 103.242 22.5551 102.641 22.7012C102.04 22.8474 101.447 22.9205 100.862 22.9205Z"
            fill="#263248"
          />
          <path
            d="M108.048 22.6769V9.7885H111.386L111.508 13.9303L110.923 13.0776C111.118 12.4117 111.434 11.8107 111.873 11.2747C112.312 10.7224 112.823 10.292 113.408 9.98341C114.009 9.6748 114.634 9.5205 115.284 9.5205C115.56 9.5205 115.828 9.54486 116.088 9.59359C116.348 9.64232 116.567 9.69917 116.746 9.76414L115.82 13.5649C115.625 13.4674 115.389 13.3862 115.113 13.3212C114.837 13.24 114.553 13.1994 114.261 13.1994C113.871 13.1994 113.505 13.2725 113.164 13.4187C112.839 13.5486 112.555 13.7435 112.312 14.0034C112.068 14.247 111.873 14.5394 111.727 14.8805C111.597 15.2216 111.532 15.5952 111.532 16.0012V22.6769H108.048Z"
            fill="#263248"
          />
          <path
            d="M123.202 22.9205C121.887 22.9205 120.709 22.6363 119.67 22.0678C118.646 21.483 117.834 20.6872 117.233 19.6801C116.649 18.6731 116.356 17.5199 116.356 16.2205C116.356 14.9211 116.649 13.776 117.233 12.7852C117.834 11.7782 118.646 10.9823 119.67 10.3976C120.709 9.81286 121.887 9.5205 123.202 9.5205C124.502 9.5205 125.663 9.81286 126.686 10.3976C127.726 10.9823 128.538 11.7782 129.123 12.7852C129.708 13.776 130 14.9211 130 16.2205C130 17.5199 129.708 18.6731 129.123 19.6801C128.538 20.6872 127.726 21.483 126.686 22.0678C125.663 22.6363 124.502 22.9205 123.202 22.9205ZM123.202 19.8994C123.836 19.8994 124.404 19.7451 124.908 19.4365C125.411 19.1117 125.801 18.6731 126.077 18.1209C126.37 17.5524 126.516 16.9189 126.516 16.2205C126.516 15.5058 126.37 14.8724 126.077 14.3201C125.801 13.7517 125.411 13.3131 124.908 13.0045C124.404 12.6797 123.836 12.5172 123.202 12.5172C122.553 12.5172 121.976 12.6797 121.473 13.0045C120.969 13.3293 120.571 13.7679 120.279 14.3201C119.986 14.8724 119.848 15.5058 119.865 16.2205C119.848 16.9189 119.986 17.5524 120.279 18.1209C120.571 18.6731 120.969 19.1117 121.473 19.4365C121.976 19.7451 122.553 19.8994 123.202 19.8994Z"
            fill="#263248"
          />
        </svg>

        <svg
          class="fix-logo"
          xmlns="http://www.w3.org/2000/svg"
          width="23"
          height="27"
          viewBox="0 0 23 27"
          fill="none"
        >
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M21.9699 4.73964C21.9699 5.39786 21.9699 6.05609 22.0012 6.74497C22.1256 13.3573 22.2819 22.3512 11.3133 26.143L11.0002 26.2031L10.6864 26.143C6.84583 24.8194 4.37223 22.8561 2.78048 20.5833C2.78416 20.5752 2.78785 20.5671 2.79155 20.5591C-0.147356 16.3406 -0.0538935 11.0576 0.0276889 6.79059C0.0187674 6.7896 0.00984054 6.78862 0.000908355 6.78765V6.74497C0.0321665 6.05609 0.0321665 5.40087 0.0321665 4.73964C0.029883 4.61555 0.0526406 4.49227 0.099079 4.37718C0.145517 4.26208 0.214683 4.15753 0.302443 4.06977C0.390203 3.98201 0.494755 3.91284 0.609851 3.8664C0.724947 3.81997 0.848224 3.79721 0.972314 3.79949C4.8898 3.79949 7.86713 2.67119 10.3455 0.258309C10.5245 0.0922668 10.7596 0 11.0038 0C11.2479 0 11.483 0.0922668 11.662 0.258309C14.1344 2.67119 17.1117 3.79949 21.0298 3.79949C21.1539 3.79721 21.2772 3.81997 21.3923 3.8664C21.5074 3.91284 21.6119 3.98201 21.6997 4.06977C21.7874 4.15753 21.8566 4.26208 21.903 4.37718C21.9495 4.49227 21.9722 4.61555 21.9699 4.73964Z"
            fill="#89D5A3"
          />
        </svg>
      </div>
    </a>
  </div>
  <div class="nav-wrap">
    <ul class="nav-left">
      <li class="desktop-toggle">
        <a (click)="toggleFold()">
          <nz-icon nzType="home" nz-icon nzTheme="outline" />
        </a>
      </li>
      <li class="mobile-toggle">
        <a (click)="toggleExpand()">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="20"
            height="18"
            viewBox="0 0 20 18"
            fill="none"
          >
            <path
              d="M1 17L19 17M1 9L10 9M14 9L19 9M19 9L16.5 12M19 9L16.5 6M1 1L19 1"
              stroke="#313131"
              stroke-width="1.5"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
          </svg>
        </a>
      </li>
    </ul>

    <ul class="nav-right">
      <li>
        <span
          class="p-h-10 pointer"
          nz-dropdown
          [nzDropdownMenu]="profile"
          [nzTrigger]="'click'"
        >
          <nz-avatar
            [nzSize]="32"
            nzIcon="user"
            style="background-color: #87d068"
          ></nz-avatar>
        </span>
        <nz-dropdown-menu #profile="nzDropdownMenu">
          <ul nz-menu class="p-b-15 p-t-20">
            <li class="p-h-20 p-b-15 m-b-10 border-bottom">
              <div class="d-flex m-r-50">
                <div class="m-l-10">
                  <p class="m-b-0 text-dark font-weight-semibold">
                    {{ accountInfo?.account }}
                  </p>
                </div>
              </div>
            </li>
            <li nz-menu-item>
              <a
                class="p-v-5 d-flex align-items-center justify-content-between"
                [routerLink]="['/account/profile']"
              >
                <div>
                  <i
                    class="opacity-04 font-size-16"
                    nz-icon
                    nzType="user"
                    theme="outline"
                  ></i>
                  <span class="m-l-10">Profile</span>
                </div>
                <i
                  class="font-size-10"
                  nz-icon
                  nzType="right"
                  theme="outline"
                ></i>
              </a>
            </li>
            <li nz-menu-item>
              <a
                class="p-v-5 d-flex align-items-center justify-content-between"
              >
                <div>
                  <i
                    class="opacity-04 font-size-16"
                    nz-icon
                    nzType="logout"
                    theme="outline"
                  ></i>
                  <span class="m-l-10" (click)="logout()">Logout</span>
                </div>
                <i
                  class="font-size-10"
                  nz-icon
                  nzType="right"
                  theme="outline"
                ></i>
              </a>
            </li>
          </ul>
        </nz-dropdown-menu>
      </li>
    </ul>
  </div>
</div>
<!-- <div class="container-color">
    <div class="list-color" *ngIf="!isHide">
        <div class="d-flex" (click)="changeTheme('primary')" style="cursor: pointer;">
            <div class="color color-primary mb-2" [class.active-color]="theme === 'primary'"></div>
            <span class="ml-3">Primary </span>
        </div>
        <div class="d-flex" (click)="changeTheme('dark-night')" style="cursor: pointer;">
            <div class="color color-dark-night mb-2" [class.active-color]="theme === 'dark-night'"></div>
            <span class="ml-3">Dark </span>
        </div>
        <div class="d-flex" (click)="changeTheme('default')" style="cursor: pointer;">
            <div class="color color-default mb-2" [class.active-color]="theme === 'default'"></div>
            <span class="ml-3">Default </span>
        </div>
        <div class="d-flex" (click)="changeTheme('dynamic')" style="cursor: pointer;">
            <div class="color color-dynamic mb-2" [class.active-color]="theme === 'dynamic'"></div>
            <span class="ml-3">Dynamic </span>
        </div>

        <div class="sub-dynamic-color d-flex flex-column" *ngIf="theme === 'dynamic'">
            <input (colorPickerChange)="changeColor($event)"  [style.background]="color" [cpPosition]="'left'" style="display: none;" id="idPickColor"/>
            <div class="d-flex">
                <span class="mr-2">Background color: </span>
                <div class="color" [style.background-color]="dynamicColor.color" [(colorPicker)]="color"
                    [cpPosition]="'left'" (colorPickerSelect)="changeColor('color')"
                    [(colorPicker)]="dynamicColor.color"></div>
            </div>
            <div class="d-flex">
                <span class="mr-2">Text color: </span>
                <div class="color" [style.background-color]="dynamicColor.color1" [(colorPicker)]="color"
                    [cpPosition]="'left'" (colorPickerSelect)="changeColor('color1')"
                    [(colorPicker)]="dynamicColor.color1"></div>
            </div>
            <div class="d-flex">
                <span class="mr-2">Menu effect: </span>
                <div class="color" [style.background-color]="dynamicColor.color4" [(colorPicker)]="color"
                    [cpPosition]="'left'" (colorPickerSelect)="changeColor('color4')"
                    [(colorPicker)]="dynamicColor.color4"></div>
            </div>
            <div class="d-flex">
                <span class="mr-2">Table background: </span>
                <div class="color" [style.background-color]="dynamicColor.color5" [(colorPicker)]="color"
                    [cpPosition]="'left'" (colorPickerSelect)="changeColor('color5')"
                    [(colorPicker)]="dynamicColor.color5"></div>
            </div>
            <div class="d-flex">
                <span class="mr-2">Table body text: </span>
                <div class="color" [style.background-color]="dynamicColor.color2" [(colorPicker)]="color"
                    [cpPosition]="'left'" (colorPickerSelect)="changeColor('color2')"
                    [(colorPicker)]="dynamicColor.color2"></div>
            </div>
        </div>
    </div>
    <div class="btn-container btn-container-right" (click)="hideTheme()" *ngIf="!isHide">
        <i class="font-size-10 icon-hide" nz-icon nzType="right" theme="outline"></i>
    </div>
    <div class="btn-container btn-container-left" (click)="showTheme()" *ngIf="isHide">
        <i class="font-size-10 icon-hide" nz-icon nzType="left" theme="outline"></i>
        <span class="ml-1">Theme</span>
    </div>
</div> -->
